
export class PublicoAlvoAtividade {
    id: number;
    descricao: string;
    idAtividade: number;
	idPublicoAlvo: number;
    idUsuarioAplicacao: number;
	idInstituicao: number;
}